import React from 'react';
import { useDispatch } from 'react-redux';
import { useProUpsellModal } from '../../../../hooks/use_pro_upsell_modal';
import { useUser } from '../../../../hooks/use_user';
import { SignupLoginModalActions } from '../../../../redux/signup_login_modal';
import { PRO_TRIAL_SIGNUP_LOGIN_MODAL_OPEN_PARAMS } from '../../../login_signup_modal/signup_login_modal';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import SvgLockIcon from '../../../svg/lock_icon';
import styles from './conditions_upgrade.less';

export const ConditionsUpgrade = () => {
  const { user } = useUser();
  const dispatch = useDispatch();
  const { openProUpsellModal } = useProUpsellModal();

  return (
    <div className={styles.container}>
      <span className={styles.heading}>
        <SvgLockIcon /> Unlock All Conditions
      </span>
      <span>
        Get access to all conditions by
        <br /> upgrading to Omnia PRO
      </span>
      <OmniaButton
        kind="tertiary"
        size="md"
        block
        onPress={() => {
          if (user) {
            openProUpsellModal();
          } else {
            dispatch(
              SignupLoginModalActions.SIGNUP_LOGIN_MODAL_OPEN(
                PRO_TRIAL_SIGNUP_LOGIN_MODAL_OPEN_PARAMS
              )
            );
          }
        }}
      >
        Start 7-Day FREE Trial
      </OmniaButton>
      <span className={styles.proBadge}>PRO</span>
    </div>
  );
};
